import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpResponse, HttpUtilService } from "../http-util.service";

@Injectable({
  providedIn: "root",
})
export class COEStockDetailReportService {
  constructor(private http: HttpUtilService) {}

  COEStockDetailReport(model: {
    BidFor: string;
    Type: string;
  }): Observable<HttpResponse<any>> {
    return this.http.post(
      `AutopacReportService.asmx/COEStockDetailReport`,
      {
        model: model,
      },
    );
  }
}
